import React from "react";
import {useSelector} from "react-redux";

/**
 * Embeds the "clean" PDF of an admission document - a plain structured listing of the patient answers.
 *
 * The JWT travels as a query parameter rather than an Authorization header: an iframe cannot set headers,
 * and the browser PDF viewer re-requests this exact URL when its own download button is pressed - posting
 * the token into the frame instead would make that download fail.
 */
const AdmissionDocumentCleanPdf = ({documentId, width = '100%', height = 620}) => {
    const idToken = useSelector(state => state.auth.idToken);
    const src = `${process.env.REACT_APP_API_PATH}/admission/document/${documentId}/clean-pdf?token=${encodeURIComponent(idToken)}`;

    return (
        <iframe
            title="Clean PDF"
            style={{border: "none"}}
            width={width}
            height={height}
            src={src}
        />
    )
}

export default AdmissionDocumentCleanPdf;
